import React from 'react'
import {
  track,
  identify,
  trackPage,
  resetSegmentIdentity,
  trackExperimentViewed,
  trackExperimentBucketed,
} from '@mc/track-event'
import { SegmentTrackingContext, TrackOptions } from '@mc/tracking-context'

const defaultIntegrations = {
  All: true,
  'Bing Ads': false,
  'Facebook CAPI': false,
  'Facebook Pixel': false,
  'Google AdWords New': false,
  'Google Tag Manager': false,
  Hotjar: false,
  ShareASale: false,
  TikTok: false,
}

const goldStandardIntegrations = {
  All: true,
  'Bing Ads': true,
  'Facebook CAPI': true,
  'Facebook Pixel': true,
  'Google AdWords New': true,
  'Google Tag Manager': true,
  ShareASale: true,
  TikTok: true,
}

const wrappedTrack = (
  event: string,
  properties?: Record<
    string,
    string | number | boolean | object | null | undefined
  >,
  options?: TrackOptions,
) =>
  track(event, properties, {
    integrations: options?.integrations ?? defaultIntegrations,
  })

const wrappedTrackPage = (
  event?: string,
  properties?: Record<string, unknown>,
  options?: TrackOptions,
) =>
  trackPage(
    event,
    { platform: 'next', ...properties },
    { integrations: options?.integrations ?? goldStandardIntegrations },
  )

export const SegmentTrackingProvider = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <SegmentTrackingContext.Provider
    value={{
      identify,
      track: wrappedTrack,
      trackPage: wrappedTrackPage,
      resetSegmentIdentity,
      trackExperimentViewed,
      trackExperimentBucketed,
    }}
  >
    {children}
  </SegmentTrackingContext.Provider>
)
